export const REVENUE_INTELLIGENCE_HOME_PATH = "/home";
export const REVENUE_INTELLIGENCE_AGENTS_PATH = "/agents";
export const STATE_OF_SALES_PATH = "/state-of-sales";
export const FORECAST_DIAGNOSIS_PATH = "/forecast-diagnosis";
export const REVENUE_INTELLIGENCE_FILTER_CONTEXT_CHANGED_EVENT = "revelate:revenue-intelligence-filter-context-changed";
export const DEFAULT_REVENUE_INTELLIGENCE_PERIOD = "next_6_months";
const REVENUE_INTELLIGENCE_PERIOD_STORAGE_KEY = "revelate:revenue-intelligence-period";
const REVENUE_INTELLIGENCE_FORECAST_PERIODS = new Set([
  "prev_quarter",
  "this_quarter",
  "next_quarter",
  "next_6_months",
  "this_year",
]);
const REVENUE_INTELLIGENCE_FILTER_KEYS = [
  "pipeline",
  "team",
  "owner",
  "accumulated",
] as const;

function getStoredRevenueIntelligencePeriod() {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(REVENUE_INTELLIGENCE_PERIOD_STORAGE_KEY);
}

function isRevenueIntelligenceForecastPeriod(value: string | null): value is string {
  return value !== null && REVENUE_INTELLIGENCE_FORECAST_PERIODS.has(value);
}

export function getRevenueIntelligencePeriod(
  currentLocation: string,
  storedPeriod = getStoredRevenueIntelligencePeriod(),
) {
  const query = currentLocation.split("?")[1] ?? currentLocation.replace(/^\?/, "");
  const currentPeriod = new URLSearchParams(query).get("period");
  if (isRevenueIntelligenceForecastPeriod(currentPeriod)) return currentPeriod;
  if (isRevenueIntelligenceForecastPeriod(storedPeriod)) return storedPeriod;
  return DEFAULT_REVENUE_INTELLIGENCE_PERIOD;
}

export function persistRevenueIntelligencePeriod(period: string) {
  if (typeof window === "undefined" || !isRevenueIntelligenceForecastPeriod(period)) return;
  window.sessionStorage.setItem(REVENUE_INTELLIGENCE_PERIOD_STORAGE_KEY, period);
}

export function buildRevenueIntelligenceContextHref(
  path: string,
  currentLocation: string,
  storedPeriod = getStoredRevenueIntelligencePeriod(),
) {
  const query = currentLocation.split("?")[1] ?? "";

  const currentParams = new URLSearchParams(query);
  const nextParams = new URLSearchParams({
    period: getRevenueIntelligencePeriod(currentLocation, storedPeriod),
  });
  for (const key of REVENUE_INTELLIGENCE_FILTER_KEYS) {
    const value = currentParams.get(key);
    if (value !== null) nextParams.set(key, value);
  }

  const nextQuery = nextParams.toString();
  return nextQuery ? `${path}?${nextQuery}` : path;
}

export function isRevenueIntelligenceProductPath(pathname: string) {
  const path = pathname.split(/[?#]/)[0];
  return path === REVENUE_INTELLIGENCE_HOME_PATH
    || path === REVENUE_INTELLIGENCE_AGENTS_PATH
    || path === STATE_OF_SALES_PATH
    || path === FORECAST_DIAGNOSIS_PATH
    || path.startsWith(`${STATE_OF_SALES_PATH}/`)
    || path.startsWith("/revenue-intelligence/")
    || path === "/revenue-intelligence";
}

export function isRevenueIntelligenceHomePath(pathname: string) {
  return pathname.split(/[?#]/)[0] === REVENUE_INTELLIGENCE_HOME_PATH;
}

export function isRevenueIntelligenceAgentsPath(pathname: string) {
  return pathname.split(/[?#]/)[0] === REVENUE_INTELLIGENCE_AGENTS_PATH;
}
